import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";
import { ApplicationState } from "../../../store";
import { IPackage, IProduct } from "../../../store/protectionPlanService/ezs/types";
import { getUpgradeDowngradeValue } from "./GetUpgradeDowngradeCommonFunctions";
import { useTranslation } from "react-i18next";
import * as services from "../../../store/service";
import { Notification } from "../../common/Notification";



interface IProps {
    closeDialog: any;
    showUpgradeDialog: any;
    packageIndex: number;
    isTwoStepCancellation: boolean;
    isUserHaveTrial?: boolean;
    creditLockPresent?: boolean;
    isBfsCancelFlow?: boolean;
    closeUpgradeAndOpenCompletionDialog: any;
    closeUpgradeConfirmationDialog: any;
}

const ProtectionPlanUpgradeConfirmation: React.FunctionComponent<IProps> = (props) => {
    const packageList = useSelector((state: ApplicationState) => {
        if (state.protectionPlanState && state.protectionPlanState.protectionPlanData) {
            return state.protectionPlanState.protectionPlanData.packageList;
        }
    });
    const [loading, setLoading] = useState(false);
    const currentPackage = packageList?.find((pkg) => pkg.IsActive);
    const currentPackagePrice: any = currentPackage?.PackagePrice;
    let checkupgradedowngrade: string = "";
    const selectedPackage = (packageList && packageList.length >= props.packageIndex ? packageList[props.packageIndex] : null) as IPackage;
    const pkg = (
        getUpgradeDowngradeValue(selectedPackage, currentPackage).toLowerCase() === "upgrade" || selectedPackage?.ActionButtonText?.toLowerCase() === "purchase"
            ? selectedPackage
            : currentPackage
    ) as IPackage;
    const isUserPaid = useSelector((state: ApplicationState) =>
        state.myAccountServiceState ? state.myAccountServiceState.familtOffer?.familyAdultOffer?.isUserPaid : false
    );
    const familyMembers = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.familyMembers ? state.loggedInUser.familyMembers : []
    );
    const isBusinessUser = useSelector((state: ApplicationState) => state.loggedInUser && state.loggedInUser.userServiceDetails?.isBusinessUser);
    const [householdMembers, setHouseholdMembers] = useState(
        familyMembers.filter((x) => x.accountType === "Family Plan Adult") ? familyMembers.filter((x) => x.accountType === "Family Plan Adult") : []
    );
    const showPackageUpgradeDialog = () => {
        if (props.isBfsCancelFlow) {
            updateCancelpackage();

        } else {
            props.showUpgradeDialog();
        }

    };

    const updateCancelpackage = (): any => {
        const requestBody = {
            packageId: selectedPackage?.PackagId,
            packageCode: selectedPackage?.PackageCode,
            automaticRenewal: "",
            automaticRenewalAcceptance: "",
            billingInformationDTO: null,
            changeType: "CANCEL",
            familyProtectionCostPerMember: 0,
            isPayAsYouGoCurrentPackage: false,
            packagePrice: selectedPackage?.PackagePrice,
            salesTax: "0.00",
            subscriptionType: selectedPackage?.SubcriptionType,
        };
        setLoading(true);
        services
            .UpgradeDowngradePackage(requestBody)
            .then((data: any) => {

                if (!data["hasError"]) {

                    setTimeout(function () {
                        setLoading(false);
                        props.closeUpgradeConfirmationDialog();
                        props.closeUpgradeAndOpenCompletionDialog();
                    }, 3000);
                } else {
                    setLoading(false);
                    Notification({
                        type: "error",
                        title: tLang("manageAccount.protectionPlan.notification.errorTitle"),
                        message: tLang("manageAccount.protectionPlan.notification.somethingWentWrongMsg"),
                    });
                }
            })
            .catch(function (error: any) {
                setLoading(false);
                Notification({
                    type: "error",
                    title: tLang("manageAccount.protectionPlan.notification.errorTitle"),
                    message: tLang("manageAccount.protectionPlan.notification.somethingWentWrongMsg"),
                });
            });


    }


    const { t: tLang } = useTranslation();

    useEffect(() => {
        const households = familyMembers.filter((x) => x.accountType === "Family Plan Adult")
            ? familyMembers.filter((x) => x.accountType === "Family Plan Adult")
            : [];
        setHouseholdMembers(households);
    }, [familyMembers.length]);

    useEffect(() => {
        window.addEventListener("keyup", (evt: any) => {
            evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = evt.key === "Escape" || evt.key === "Esc";
            } else {
                isEscape = evt.keyCode === 27;
            }
            if (isEscape) {
                props.closeDialog();
            }
        });
        return () => {
            window.removeEventListener("keyup", () => { });
        };
    });

    useEffect(() => {
        setLoading(true);
        services.getAvalaraService().then(() => {
            setLoading(false);
        })
        .catch(function (error: any) {
            setLoading(false);
            Notification({
                type: "error",
                title: tLang("manageAccount.protectionPlan.notification.errorTitle"),
                message: tLang("manageAccount.protectionPlan.notification.somethingWentWrongMsg"),
            });
        });
      
    }, [props.isBfsCancelFlow]);

    const displayProduct = (product: IProduct, index: number) => {
        if (selectedPackage.ActionButtonText !== "Cancel") {
            checkupgradedowngrade = getUpgradeDowngradeValue(selectedPackage, currentPackage);
        }
        if (selectedPackage.ActionButtonText === "Purchase") {
            if (product.displayName) {
                return (
                    <li key={"product_" + index}>
                        <em className="las la-check-circle inline-icon status-good"></em>
                        <span> {product.displayName}</span>
                    </li>
                );
            }
        } else if (checkupgradedowngrade.toLocaleLowerCase() === "upgrade") {
            const foundProduct = currentPackage?.Products?.find((it: IProduct) => it.id === product.id);
            const foundProductName = currentPackage?.Products?.find((it: IProduct) => it.displayName === product.displayName);
            if (!foundProduct && product.displayName && !foundProductName) {
                return (
                    <li key={"product_" + index}>
                        <em className="las la-check-circle inline-icon status-good"></em>
                        <span> {product.displayName}</span>
                    </li>
                );
            }
        } else if (checkupgradedowngrade.toLowerCase() === "downgrade") {
            const foundProduct = selectedPackage.Products?.find((it: IProduct) => it.id === product.id);
            const foundProductName = selectedPackage?.Products?.find((it: IProduct) => it.displayName === product.displayName);
            if (!foundProduct && product.displayName && !foundProductName) {
                return (
                    <li key={"product_" + index}>
                        <em className="las la-minus-circle inline-icon status-bad"></em>
                        <span> {product.displayName} </span>
                    </li>
                );
            }
        } else {
            if (product.displayName) {
                return (
                    <li key={"product_" + index}>
                        <em className="las la-minus-circle inline-icon status-bad"></em>
                        <span> {product.displayName} </span>
                    </li>
                );
            }
        }
    };

    const displayConfirmationMessage = () => {
        if (selectedPackage?.ActionButtonText?.toLowerCase() !== "cancel") {
            checkupgradedowngrade = getUpgradeDowngradeValue(selectedPackage, currentPackage);
        }
        if (selectedPackage?.ActionButtonText?.toLowerCase() === "purchase") {
            return (
                <p>
                    {tLang("manageAccount.protectionPlan.changePlanConfirmationPopup.purchasePlanMsg.text1")} {selectedPackage?.PackageName}
                    {isBusinessUser
                        ? tLang("manageAccount.protectionPlan.changePlanConfirmationPopup.purchasePlanMsg.business")
                        : tLang("manageAccount.protectionPlan.changePlanConfirmationPopup.purchasePlanMsg.identity")}
                </p>
            );
        } else if (checkupgradedowngrade.toLowerCase() === "upgrade") {
            return (
                <p>
                    {tLang("manageAccount.protectionPlan.changePlanConfirmationPopup.continueupgradePlanMsg.text1")} {currentPackage?.PackageName}{" "}
                    {tLang("manageAccount.protectionPlan.changePlanConfirmationPopup.continueupgradePlanMsg.text2")} {selectedPackage?.PackageName}
                    {isBusinessUser
                        ? tLang("manageAccount.protectionPlan.changePlanConfirmationPopup.continueupgradePlanMsg.business")
                        : tLang("manageAccount.protectionPlan.changePlanConfirmationPopup.continueupgradePlanMsg.identity")}
                </p>
            );
        } else if (checkupgradedowngrade.toLowerCase() === "downgrade") {
            return (
                <p>
                    {tLang("manageAccount.protectionPlan.changePlanConfirmationPopup.continuedowngradePlanMsg.text1")} {currentPackage?.PackageName}{" "}
                    {tLang("manageAccount.protectionPlan.changePlanConfirmationPopup.continuedowngradePlanMsg.text2")} {selectedPackage?.PackageName}
                    {isBusinessUser
                        ? tLang("manageAccount.protectionPlan.changePlanConfirmationPopup.continuedowngradePlanMsg.business")
                        : tLang("manageAccount.protectionPlan.changePlanConfirmationPopup.continuedowngradePlanMsg.identity")}
                </p>
            );
        } else {
            return (
                <p>
                    {isBusinessUser
                        ? tLang("manageAccount.protectionPlan.changePlanConfirmationPopup.cancelBusinessPlanMsg")
                        : props.isTwoStepCancellation && props.isUserHaveTrial ? tLang("manageAccount.protectionPlan.changePlanConfirmationPopup.twoStepCancelTrialPlanMsg")
                            : tLang("manageAccount.protectionPlan.changePlanConfirmationPopup.cancelIdentityPlanMsg")}
                </p>
            );
        }
    };

    const dialogTitle = () => {
        if (selectedPackage?.ActionButtonText?.toLowerCase() === "purchase") {
            return tLang("manageAccount.protectionPlan.changePlanConfirmationPopup.confirmPurchase");
        } else if (selectedPackage?.ActionButtonText?.toLowerCase() === "select") {
            return tLang("manageAccount.protectionPlan.changePlanConfirmationPopup.confirmContinue");
        }
        else {
            return props.isUserHaveTrial && props.isTwoStepCancellation ? tLang("manageAccount.protectionPlan.changePlanConfirmationPopup.confirmTrialCancelation")
                : tLang("manageAccount.protectionPlan.changePlanConfirmationPopup.confirmCancelation")
        }
    };

    const confirmButtonTitle = () => {
        if (selectedPackage?.ActionButtonText?.toLowerCase() === "purchase") {
            return tLang("manageAccount.protectionPlan.changePlanConfirmationPopup.continuePurchase");
        } else if (selectedPackage?.ActionButtonText?.toLowerCase() === "select") {
            return tLang("manageAccount.protectionPlan.changePlanConfirmationPopup.continueSelect");
        } else {
            return tLang("manageAccount.protectionPlan.changePlanConfirmationPopup.continueCancelation");
        }
    };

    return (
        /*   loading ?
                      <div className="col-xs">
                          <div className={`box offset-padding loading`}></div>
                      </div> : */
        <React.Fragment>
            <div className="dialog-header">
                <div className="dialog-icon">
                    <RenderIcons iconName="coins" />
                </div>
                <h1>{dialogTitle()}</h1>
            </div>

            <div className={loading ? "loading dialog-body" : "dialog-body"}>
                {displayConfirmationMessage()}

                <ul className="list-reset">{pkg?.Products && pkg.Products?.map((product, index: number) => displayProduct(product as IProduct, index))}</ul>
                {isUserPaid && confirmButtonTitle() === "Continue with Cancelation" && householdMembers && householdMembers.length > 0 && (
                    <>
                        <p></p>
                        <p>{tLang("manageAccount.protectionPlan.changePlanConfirmationPopup.alsoCancelServicesMsg")}</p>
                        <ul className="list-reset">
                            {householdMembers.map((member, index) => {
                                return (
                                    <li key={"household_members_" + index}>
                                        <em className="las la-minus-circle inline-icon status-bad"></em>
                                        <span>{` ${member.firstName} ${member.lastName}`}</span>
                                    </li>
                                );
                            })}
                        </ul>
                    </>
                )}
                {(props.creditLockPresent) ? <p className="credit-lock-msg">{tLang("manageAccount.protectionPlan.changePlanConfirmationPopup.creditLockMsg")}{" "}
                    <a
                        className="default_link link"
                        href="https://service.transunion.com/dss/orderStep1_form.page?"
                        target="_blank"
                        rel="noreferrer"
                        onClick={(e: any) => {
                            e.stopPropagation();
                        }}
                    >
                        {tLang("manageAccount.protectionPlan.changePlanConfirmationPopup.freeCreditFreeze")}
                    </a>
                    .</p> : ''
                }
            </div>

            <div className="dialog-footer">
                <div className="row between-xs">
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button
                            type="button"
                            className="btn-default btn-link btn-no-padding btn-no-border"
                            id="btn-cancel-upgrade-confirmation"
                            onClick={() => {
                                window.addToDataLayer({ event: "Protection Plan - Close confirmation" });
                                props.closeDialog();
                            }}
                        >
                            <span className="btn-text">{tLang("manageAccount.protectionPlan.btn.cancel")}</span>
                        </button>
                    </div>
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button
                            type="button"
                            className="btn-default btn-primary"
                            id="btn-submit-upgrade-confirmation"
                            onClick={() => {
                                window.addToDataLayer({ event: "Protection Plan - Continue " + selectedPackage.ActionButtonText?.toUpperCase() });
                                showPackageUpgradeDialog();
                            }}
                        >
                            <span className="btn-text">{confirmButtonTitle()}</span>
                        </button>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};
export default ProtectionPlanUpgradeConfirmation;
